const parametersOptionsCalculator = [{ value: "rate", label: "Rate" }]

const parametersOptionsExpression = [
  { value: "count", label: "Count" },
  { value: "rate", label: "Rate" },
  { value: "limit", label: "Limit" },
  { value: "checkoutSelection", label: "Checkout Selection" }
]

const scopeTypeOptionsCalculator = [
  { value: "event-type", label: "Event-Type" },
  { value: "input", label: "Input" }
]

const scopeTypeOptionsExpression = [
  { value: "event-type", label: "Event-Type" },
  { value: "user-count", label: "User Count" }
]

export const selectors = {
  parametersOptionsCalculator,
  parametersOptionsExpression,
  scopeTypeOptionsCalculator,
  scopeTypeOptionsExpression
}

export const benefitsSeparator = {
  value: ",",
  label: "vírgula"
}

export const initialPurchasePlan = {
  _id: "",
  planKey: "",
  name: "",
  description: "",
  benefits: [],
  fromPrice: 0,
  fromPriceUnit: "",
  product: "",
  pricingExpression: {
    strExpression: "",
    scope: []
  },
  pricingCalculator: {
    strExpression: "",
    scope: []
  },
  isEnterprise: false,
  isPublished: true
}

export const initialPricingExpression = {
  variableNameInExpression: "",
  parameter: "",
  scopeType: "event-type",
  source: ""
}

export const initialPricingCalculator: App.PricingCalculatorItem = {
  variableNameInExpression: "",
  parameter: "",
  scopeType: "",
  source: "",
  variableLabelForDisplay: "",
  min: "",
  max: "",
  baseUnit: "",
  isVisible: false,
  isCalculated: false,
  pricingCalculator: {
    strExpression: "",
    scope: []
  }
}

export const initialPricingCalculatorVariable = {
  variableNameInExpression: "",
  variableLabelForDisplay: "",
  source: "",
  scopeType: "",
  parameter: "",
  isCalculated: false,
  pricingCalculator: {
    strExpression: "",
    scope: []
  }
}

export enum PricingTypes {
  CALCULATOR = "calculator",
  VARIABLE_CALCULATOR = "variable-calculator",
  EXPRESSION = "expression"
}

export enum PricingUnits {
  CONSUMPTION = "consumption",
  MONTHLY = "monthly"
}

export enum PricingUnitsLabel {
  CONSUMPTION = "por uso",
  MONTHLY = "mês"
}

export const unitSelectorOptions = [
  {
    value: PricingUnits.CONSUMPTION,
    label: "/Por uso (Tipos de Eventos)"
  },
  {
    value: PricingUnits.MONTHLY,
    label: "/Mensal"
  }
]

export const tabIds = {
  plans: "plans",
  benefits: "benefits"
}

export const planFormHeadingText = {
  create: "Para criar um plano, preencha as informações de acordo com os campos abaixo:",
  update: "Para atualizar um plano, preencha as informações de acordo com os campos abaixo:"
}
